import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PoButtonModule, PoPageModule } from '@po-ui/ng-components';
import { TranslateModule } from '@ngx-translate/core';
import { AtsUiLibModule } from 'ats-ui-lib';
import { NoStandaloneSharedModule } from '../../no-standalone-shared/no-standalone-shared.module';
import { EasyApplyModalService } from '../easy-apply/easy-apply-modal.service';
import { SupportButtonService } from '@shared/support-button/services/support-button.service';

@Component({
  selector: 'ats-easy-apply-success',
  imports: [
    CommonModule,
    RouterModule,
    PoPageModule,
    PoButtonModule,
    TranslateModule,
    AtsUiLibModule,
    NoStandaloneSharedModule,
  ],
  template: `
    <div>
      <div class="success-container">
        <div class="success-info">
          <h1>{{ 'l-easy-apply-success-heading' | translate }}</h1>
          <p>{{ 'l-easy-apply-success-body-message' | translate }}</p>
        </div>

        <div class="success-illustration" aria-hidden="true">
          <img
            src="assets/images/imagem_pessoa_sentada.svg"
            alt=""
            class="success-illustration__image"
          />
        </div>
      </div>

      <ats-footer (heightChanged)="footerHeight = $event" *ngIf="showFooter()">
        <div class="po-row">
          <div
            class="po-offset-md-7 po-md-5 po-offset-xl-8 po-xl-4 po-offset-lg-8 po-lg-4 po-p-0 footer-actions"
          >
            <po-button
              class="po-sm-12 po-md-12 po-lg-12 po-xl-12"
              p-kind="primary"
              [p-label]="'l-close' | translate"
              [atsLibFieldAriaLabel]="'l-close' | translate"
              (p-click)="onClose()"
              data-cy="easy-apply-success-close"
            >
            </po-button>
          </div>
        </div>
      </ats-footer>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        height: 100%;
      }

      .success-info h1 {
        font-size: 26px;
        margin-top: 16px;
        margin-bottom: 20px;
      }

      .success-info p {
        margin: 0 0 14px;
        color: var(--color-neutral-90);
        line-height: 1.5;
      }

      .success-illustration {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .success-illustration__image {
        width: 300px;
        height: 300px;
        object-fit: contain;
        display: block;
      }

      :host ::ng-deep .footer__content {
        padding: 0px !important;
      }

      @media (min-width: 768px) {
        .success-container {
          grid-template-columns: 1.2fr 0.8fr;
          align-items: center;
        }
      }
    `,
  ],
})
export class EasyApplySuccessComponent {
  footerHeight = '0px';

  public showFooter = input<boolean>(true);

  constructor(
    private readonly supportButtonService: SupportButtonService,
    private readonly easyApplyModalService: EasyApplyModalService,
  ) {
    this.supportButtonService.hide();
  }

  onClose(): void {
    history.back();
    this.easyApplyModalService.closeModal();
  }
}
